import { colorAttentionBlue50, colorFunctionalGray30, iconSizeL, spacingL, spacingS, } from "@rhumbix/rmbx_design_system_design_tokens";
import styled from "styled-components";
import React from "react";
import Toggle from "react-switch";
/**
 * @param {boolean} checked Controls the checked state of the toggle
 * @param {function} onChange The change handler for the toggle
 * @param {boolean} disabled Sets the disabled state of the toggle
 * @param {string} arialabelledby Sets the ID of the label that identifies this toggle
 * @param {string} arialabel Sets a label to attach to the toggle for screen readers
 * @returns
 */
export const MixedSlideToggle = (props) => {
    let toggleComponent;
    if (props.indeterminate) {
        const width = parseInt(spacingL);
        const height = parseInt(iconSizeL);
        const handleDiameter = height - 2;
        const borderRadius = Math.floor(height / 2);
        const handleOffset = width / 2 - handleDiameter / 2;
        const handleClick = (e) => {
            props.onChange(true, e, "mixed -> on");
        };
        // The following is a reproduction of the styling of the react-switch component as
        // we style it that re-calculates position so the handle is placed in the center
        // if we are indeterminate, otherwise this is identical to what is produced
        // by the standard return from this function
        toggleComponent = (React.createElement("div", { onClick: handleClick, style: {
                position: "relative",
                display: "inline-block",
                textAlign: "left",
                opacity: "1",
                direction: "ltr",
                borderRadius: borderRadius + "px",
                transition: "opacity 0.25s ease 0s",
                touchAction: "none",
                userSelect: "none",
            } },
            React.createElement("div", { className: "react-switch-bg", style: {
                    height: height + "px",
                    width: width + "px",
                    margin: "0px",
                    position: "relative",
                    background: "rgb(42, 106, 195)",
                    opacity: "0.5",
                    borderRadius: borderRadius + "px",
                    cursor: "pointer",
                    transition: "background 0.25s ease 0s",
                } }),
            React.createElement("div", { className: "react-switch-handle", style: {
                    height: handleDiameter + "px",
                    width: handleDiameter + "px",
                    background: "rgb(255, 255, 255)",
                    display: "inline-block",
                    cursor: "pointer",
                    borderRadius: "50%",
                    position: "absolute",
                    transform: "translateX(" + handleOffset + "px)",
                    top: "1px",
                    outline: "0px",
                    border: "0px none",
                    transition: "background-color 0.25s ease 0s, transform 0.25s ease 0s, box-shadow 0.15s ease 0s",
                } })));
    }
    else {
        toggleComponent = (React.createElement(Toggle, { checked: props.checked, onChange: props.onChange, disabled: props.disabled, onColor: colorAttentionBlue50, offColor: colorFunctionalGray30, checkedIcon: false, uncheckedIcon: false, height: parseInt(iconSizeL), width: parseInt(spacingL), name: props.name, "aria-label": props.arialabel }));
    }
    let label;
    if (props.indeterminate) {
        label = "Mixed";
    }
    else if (props.checked) {
        label = "Yes";
    }
    else {
        label = "No";
    }
    return (React.createElement(SlideToggleContainer, null,
        toggleComponent,
        React.createElement("span", { style: {
                paddingLeft: parseInt(spacingS),
                fontStyle: props.indeterminate ? "italic" : "normal",
            } }, label)));
};
const SlideToggleContainer = styled.span `
    display: flex;
    align-items: center;

    .slide-toggle {
        margin-right: 8px;
    }
`;
export default MixedSlideToggle;
